import { __rest } from "tslib";
import React from 'react';
import { isWeightImperial, isWeightMetric } from './types';
import { ComponentSize } from '../types';
import { InputGroup } from '../InputGroup';
import { withLabels } from '../../hoc';
import { Container, TextField, Row, Button } from './styled';
export const WeightInput = withLabels((_a) => {
    var { size = ComponentSize.base, hasError, className } = _a, rest = __rest(_a, ["size", "hasError", "className"]);
    return (React.createElement(Container, { className: className },
        React.createElement(Row, null,
            isWeightMetric(rest) && (React.createElement(InputGroup, null,
                React.createElement(TextField, Object.assign({ size: size, onChange: rest.handleChangeGram, name: "gram", type: "number", value: rest.gram, hasError: hasError }, rest)),
                React.createElement(Button, { hasError: hasError, size: size }, "g"))),
            isWeightImperial(rest) && (React.createElement(React.Fragment, null,
                React.createElement(InputGroup, null,
                    React.createElement(TextField, Object.assign({ size: size, onChange: rest.handleChangePound, name: "ounce", type: "number", value: rest.pound, hasError: hasError }, rest)),
                    React.createElement(Button, { hasError: hasError, size: size }, "lb")),
                React.createElement(InputGroup, null,
                    React.createElement(TextField, Object.assign({ size: size, onChange: rest.handleChangeOunce, name: "pound", type: "number", value: rest.ounce, hasError: hasError }, rest)),
                    React.createElement(Button, { hasError: hasError, size: size }, "oz")))))));
});
WeightInput.displayName = 'WeightInput';
WeightInput.defaultProps = {
    weightUnit: 'lb',
};
//# sourceMappingURL=WeightInput.js.map